import { useDispatch } from "react-redux";
import { updateBackup, updateCard, updateRestore } from "../../slices/dataSlice";
import { useNotifier } from "../notifications/notificationActions";

export const useConnectionHooks = (connection) =>{

  const dispatch = useDispatch();
  const [notifySuccess, notifyInfo] = useNotifier();

  const addConnectionHooks = () => {  
   
    if (connection){
      connection.on(`Backup`,
      message => {    
        dispatch(updateBackup(JSON.parse(message)));
        //notifyInfo("Backup status updated", "bckp_upd");     
      });

      connection.on(`Card`,
      message => {    
        dispatch(updateCard(JSON.parse(message)));
        //notifyInfo("Backup status updated", "bckp_upd");     
      });

      connection.on(`Restore`,
      message => {          
        dispatch(updateRestore(JSON.parse(message)));
        //notifyInfo("Backup status updated", "bckp_upd");     
      });    
    }
   
  };
  
  const disposeConnectionHooks = () => {
    if(connection){
      connection.off(`Backup`, () => { });
      connection.off(`Restore`, () => { });
      connection.off(`Card`, () => { });
    }
  };

  return [addConnectionHooks, disposeConnectionHooks];

}

